/**
 * Shop category sidebar.
 * - Dedicated collection URLs → normal navigation (reliable)
 * - /collections/all?filter.p.tag=… → FacetFiltersForm AJAX
 */
(function () {
  const BAR_SELECTOR = '.taupe-catalog-category-bar';
  const LINK_SELECTOR = '.taupe-catalog-category-filter__link';

  function getCategoryFromUrl() {
    const params = new URLSearchParams(window.location.search);
    return (
      params.get('filter.p.tag') ||
      params.get('taupe_category') ||
      ''
    );
  }

  function collectionHandleFromPath() {
    const match = window.location.pathname.match(/\/collections\/([^/?#]+)/i);
    return match ? decodeURIComponent(match[1]).toLowerCase() : '';
  }

  function pageHandleFromPath() {
    const match = window.location.pathname.match(/\/pages\/([^/?#]+)/i);
    return match ? decodeURIComponent(match[1]).toLowerCase() : '';
  }

  function setActiveLink() {
    const tagOrParam = getCategoryFromUrl().toLowerCase();
    const handle = collectionHandleFromPath();
    const pageHandle = pageHandleFromPath();

    document.querySelectorAll(LINK_SELECTOR).forEach((link) => {
      const linkKey = (link.dataset.taupeCategory || '').toLowerCase();
      const href = link.getAttribute('href') || '';
      let isActive = false;

      if (!linkKey) {
        isActive = handle === 'all' && !tagOrParam && !pageHandle;
      } else if (linkKey === 'taupe-hair' && pageHandle === 'shop-taupe-hair') {
        isActive = true;
      } else if (linkKey === 'taupe-tools' && pageHandle === 'shop-taupe-tools') {
        isActive = true;
      } else if (tagOrParam && tagOrParam === linkKey) {
        isActive = true;
      } else if (handle && handle === linkKey && linkKey !== 'taupe-hair' && linkKey !== 'taupe-tools') {
        isActive = true;
      } else if (
        href.includes(`/collections/${linkKey}`) &&
        linkKey !== 'taupe-hair' &&
        linkKey !== 'taupe-tools'
      ) {
        isActive = handle === linkKey;
      }

      link.classList.toggle('is-active', isActive);
      if (isActive) link.setAttribute('aria-current', 'true');
      else link.removeAttribute('aria-current');
    });
  }

  function isAllCollectionPath(pathname) {
    return /\/collections\/all\/?$/i.test(pathname);
  }

  function onDocumentClick(event) {
    const link = event.target.closest(LINK_SELECTOR);
    if (!link || !link.closest(BAR_SELECTOR)) return;

    let url;
    try {
      url = new URL(link.href, window.location.origin);
    } catch (e) {
      return;
    }

    // Real collection pages (not /collections/all) — full navigation
    if (!isAllCollectionPath(url.pathname)) {
      return;
    }

    // Same-page native tag filter — let Dawn facets handle via full nav for reliability
    // Full page load is more reliable than AJAX for filter.p.tag
    return;
  }

  function boot() {
    setActiveLink();
    if (!document.documentElement.dataset.taupeCategoryDelegated) {
      document.documentElement.dataset.taupeCategoryDelegated = 'true';
      document.addEventListener('click', onDocumentClick);
      window.addEventListener('popstate', setActiveLink);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
